import { CURRENCY } from '~/types'
import { CurrencyPair, SwapCurrencyPair } from './types'

export enum SWAP_ACTIONS {
  SET_SWAP_FX_RATE = 'SWAP_ACTIONS.SET_SWAP_FX_RATE',
  SET_SWAP_FX_RATE_STATUS = 'SWAP_ACTIONS.SET_SWAP_FX_RATE_STATUS',
  SET_SWAP_FX_QUOTE = 'SWAP_ACTIONS.SET_SWAP_FX_QUOTE',
  SET_SWAP_FX_QUOTE_STATUS = 'SWAP_ACTIONS.SET_SWAP_FX_QUOTE_STATUS',
  SET_SWAP_TRANSACTION_LIMITS = 'SWAP_ACTIONS.SET_SWAP_TRANSACTION_LIMITS',
  SET_SHOULD_HIGHLIGHT_SWAP_FORM = 'SWAP_ACTIONS.SET_SHOULD_HIGHLIGHT_SWAP_FORM',
}

// TODO(duy): move these to swap store helpers
export const AVAILABLE_SWAP_PAIRS: CurrencyPair[] = [
  { pair: [CURRENCY.SGD, CURRENCY.USD], disabled: false },
  { pair: [CURRENCY.SGD, CURRENCY.XSGD], disabled: false },
  { pair: [CURRENCY.SGD, CURRENCY.USDC], disabled: false },
  { pair: [CURRENCY.SGD, CURRENCY.XUSD], disabled: false },
  { pair: [CURRENCY.SGD, CURRENCY.USDT], disabled: false },
  { pair: [CURRENCY.XSGD, CURRENCY.SGD], disabled: false },
  { pair: [CURRENCY.XSGD, CURRENCY.USD], disabled: false },
  { pair: [CURRENCY.XSGD, CURRENCY.USDC], disabled: false },
  { pair: [CURRENCY.XSGD, CURRENCY.XUSD], disabled: false },
  { pair: [CURRENCY.XSGD, CURRENCY.USDT], disabled: false },
  { pair: [CURRENCY.USDC, CURRENCY.XSGD], disabled: false },
  { pair: [CURRENCY.USDC, CURRENCY.USD], disabled: false },
  { pair: [CURRENCY.USDC, CURRENCY.SGD], disabled: false },
  { pair: [CURRENCY.USDC, CURRENCY.XUSD], disabled: false },
  { pair: [CURRENCY.USDC, CURRENCY.USDT], disabled: false },
  { pair: [CURRENCY.USDT, CURRENCY.USD], disabled: false },
  { pair: [CURRENCY.USDT, CURRENCY.XSGD], disabled: false },
  { pair: [CURRENCY.USDT, CURRENCY.SGD], disabled: false },
  { pair: [CURRENCY.USDT, CURRENCY.USDC], disabled: false },
  { pair: [CURRENCY.USDT, CURRENCY.XUSD], disabled: false },
  { pair: [CURRENCY.XUSD, CURRENCY.XSGD], disabled: false },
  { pair: [CURRENCY.XUSD, CURRENCY.USD], disabled: false },
  { pair: [CURRENCY.XUSD, CURRENCY.SGD], disabled: false },
  { pair: [CURRENCY.XUSD, CURRENCY.USDC], disabled: false },
  { pair: [CURRENCY.XUSD, CURRENCY.USDT], disabled: false },
  { pair: [CURRENCY.USD, CURRENCY.XSGD], disabled: false },
  { pair: [CURRENCY.USD, CURRENCY.XUSD], disabled: false },
  { pair: [CURRENCY.USD, CURRENCY.USDC], disabled: false },
  { pair: [CURRENCY.USD, CURRENCY.USDT], disabled: false },
  { pair: [CURRENCY.USD, CURRENCY.SGD], disabled: false },
]

export enum SWAP_SIDE {
  SOURCE,
  DESTINATION,
}

export const PRIORITIZED_DEFAULT_SWAP_PAIRS: SwapCurrencyPair[] = [
  [CURRENCY.XSGD, CURRENCY.XUSD],
  [CURRENCY.XSGD, CURRENCY.USDT],
  [CURRENCY.XSGD, CURRENCY.USDC],
  [CURRENCY.XUSD, CURRENCY.USDT],
  [CURRENCY.XUSD, CURRENCY.USDC],
  [CURRENCY.USDC, CURRENCY.USDT],
]

export const SWAP_FIAT_CONVERSION_PAIRS: string[] = [
  'SGDXSGD',
  'XSGDSGD',
  'USDXUSD',
  'XUSDUSD',
] as const
